import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { connect, ConnectedProps } from 'react-redux';
import Text from '../../atoms/Text';
import Button from '../../atoms/button';
import Image from '../../atoms/ImageView';
import RotatingText from '../RotatingText';
import { Feature, Variant } from '../ABFeature';
import properties from '../../../modules/ajio-util/properties';
import { getSisFlag } from '../../selectors/metaData';
import { gtmEventPush } from '../../../modules/ga/GTMdatalayer';
import { getAppInstallFlag, getAppConfig, getAppsFlyerConfig } from '../../selectors/featureFlagsSelector';
import { triggerApp, checkNewUser, isMicroApp } from './utils';
import useAppInstall from './useAppInstall';
import BarCarousel from '../../atoms/BarCarousel';
import styles from './appinstall.module.pcss';
import { replaceWithJioCDN } from '../../../utils/imageHandling';
const cx = classNames.bind(styles);
const imgPath = `${properties.getProperty('imageBaseUrl')}/static/img`;
const mapStateToProps = (state: import('../../types/rootState').RootState) => ({
  appInstallFeature: getAppInstallFlag(state),
  appConfig: getAppConfig(state),
  sisFlag: getSisFlag(state),
  appsFlyerConfig: getAppsFlyerConfig(state?.flags)
});
const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
const gradiantVariation = ['nograd', 'grad1'];
const FixedBanner = ({
  id = '',
  pagetype,
  appInstallFeature = {},
  containerClass,
  gradient = 0,
  appConfig,
  sisFlag,
  appsFlyerConfig,
  origin
}: PropsFromRedux): Element.JSX => {
  const isAppInstall = useAppInstall();
  const { fixedBanner = {} } = appInstallFeature;
  const {
    image,
    downloadImage,
    newUserHeaderText,
    oldUserHeaderText,
    newUserSubtexts,
    oldUserSubtexts
  } = fixedBanner;
  const { dynamicAppInstallBanners = "OFF", carouselBanner = [] } = appInstallFeature;
  console.log("APP INSTALL FEATURE", appInstallFeature)
  const doNotRender = appInstallFeature[pagetype] !== 'ON' || sisFlag || isMicroApp();
  const impressionId =
    pagetype === 'pdp' && id === 'fixeddappintallbanner' ? 'impression_app_install_pdp' : '';
  useEffect(() => {
    if (!doNotRender) {
      const impressionFired = JSON.parse(localStorage.getItem(`${impressionId}`)) ?? false;
      if (!impressionFired) {
        localStorage.setItem(impressionId, JSON.stringify(true));
        gtmEventPush({
          event: 'app_install_widget_impression',
          category: 'widget interaction',
          action: 'app install widget impresssion',
          label: pagetype
        });
      }
    }
  }, []);
  useEffect(() => {
    window.addEventListener('beforeunload', () => {
      localStorage.removeItem(impressionId);
    });
    return () => {
      window.removeEventListener('beforeunload', () => {
        localStorage.removeItem(impressionId);
      });
    };
  }, []);
  if (doNotRender) {
    return null;
  }
  const isNewUser = checkNewUser();
  const subtexts = isNewUser ? newUserSubtexts : oldUserSubtexts;
  const gradienClass = gradiantVariation[gradient];
  return (
    <Feature featureName="appInstall">
      <Variant id="0">
        {dynamicAppInstallBanners === "ON"  && origin === 'header' ? <div id="dynamicBanner" className={`${cx(id === 'homepageBanner' ? '' : 'stickyBanner', 'placeholderBanner')}`}>
        <BarCarousel>
          {carouselBanner?.map(({ bannerImage = '', isAppInstallBanner = false, redirectionUrl = '' }) => 
            <>
              <img className={cx('dynamicBanner')} src={replaceWithJioCDN(bannerImage)} alt='Install or Open ajio app banner' onClick={() => {
                if (isAppInstallBanner) {
                  triggerApp(appConfig, pagetype, 'topnav', appsFlyerConfig)
                } else {
                  window.location.href = redirectionUrl;
                }
              }} />
            </>)}
        </BarCarousel>
        </div>
          : <>
            <section
              id={id}
              className={cx(
                pagetype === 'pdp' ? 'pdpFixedBannerContainer' : 'fixedBannerContainer',
                'flexFull',
                containerClass,
                gradienClass
              )}
            >
              <div className={cx('fixedBannerImage', { border: gradient === 0 })}>
                <Image
                  src={`${imgPath}/${image}`}
                  className={cx('fixedCategoryImage', { marginLeft: gradient === 0 })}
                />
                <Image src={`${imgPath}/${downloadImage}`} className={cx('downloadImage')} />
              </div>
              <main className={cx('fixedMainContent')}>
                <div className={cx('fixedBannerHeader')}>
                  <Text variant="T4" weight="bold">
                    {isNewUser ? newUserHeaderText : oldUserHeaderText}
                  </Text>
                </div>
                <div className={cx('appInstallSubheader')}>
                  <RotatingText textArray={subtexts} customClass={cx('fixedHeaderSubText')} />
                </div>
                <Button
                  variant="primary"
                  size="sm"
                  customClass={cx('fixedBannerButton')}
                  btnLabel={isAppInstall ? 'Use App' : 'Get App'}
                  onClick={() => triggerApp(appConfig, pagetype, 'widget', appsFlyerConfig)}
                  ariaLabel={isAppInstall ? 'Use App' : 'Get App'}
                />
              </main>
            </section>
          </> 
        }
      </Variant>
      <Variant id="1">
        <div id="ignoreComponent" />
      </Variant>
    </Feature>
  );
};
export default connector(FixedBanner);